export default __webpack_public_path__ + "static/media/icons8-gas-mask.48c57b65.svg";